// @flow

import * as React from "react";
import { ReactForm } from "@adrenalin/react-form";

import useMergableState from "../../hooks/useMergableState";
import SharedFilterFunctions from "./SharedFilterFunctions";

type PropsType = {
    data: any,
    resetUrl: string,
};

const NewsListingFilters = (props: PropsType): React.Node => {
    // Pull out data from props
    const { category: categories } = props.data;

    // State vars
    const [inputState, setInputState] = useMergableState({});

    // Create shared functions using the class factory
    const {
        renderFilterActions,
        filterGroupLooper,
        createFilterGroup,
    } = new SharedFilterFunctions(
        inputState,
        setInputState,
        "News Listing Filters"
    );

    // Create the standard filter groups for use in the filterGroupLooper
    const filterGroups = [
        createFilterGroup("checkbox", "Categories", categories),
    ];

    // Render
    return (
        <div className="filters__outer">
            <ReactForm pageSubmit disableErrorScroll>
                <div className="filters__inner">
                    <div className="filters__inputs">
                        <div className="filters__accordions news-listing-accordions">
                            {filterGroupLooper(filterGroups)}
                        </div>
                    </div>
                    {renderFilterActions(props.resetUrl)}
                </div>
            </ReactForm>
        </div>
    );
};

export default NewsListingFilters;
